module.exports = window.React;


//////////////////
// WEBPACK FOOTER
// external "window.React"
// module id = 0
// module chunks = 0